import { Button } from '@/components/atoms/button';
import { cn } from '@/libs/utils/cn';
import { MapCallout } from './MapCallout';
import { MAP_PANEL_SURFACE } from './mapPanelSurface';

export interface MapWorkspaceOnboardingProps {
  /** Opens the existing workspace-create modal. */
  onCreateWorkspace: () => void;
}

/**
 * First-run empty state shown over the map when the user has no workspace
 * yet. The surface hides the search bar and toolbox while this is visible —
 * a workspace is required before any location can be evaluated. Pixel-matches
 * the `.map-onboard` card from the SpotOn Claude Design mockup: the same card
 * chrome as the smaller callouts ({@link MAP_PANEL_SURFACE}) with
 * {@link MapCallout}'s `lg` size for the centered, larger header.
 */
export function MapWorkspaceOnboarding({ onCreateWorkspace }: MapWorkspaceOnboardingProps) {
  return (
    <div
      aria-label="Create your first workspace"
      className={cn(
        'absolute left-1/2 top-1/2 z-40 w-[380px] max-w-[calc(100%-3rem)] -translate-x-1/2 -translate-y-1/2 rounded-xl p-8 text-center',
        MAP_PANEL_SURFACE,
      )}
    >
      <MapCallout
        size="lg"
        title="Create your first workspace"
        icon={
          <svg viewBox="0 0 24 24" fill="none" className="size-7" aria-hidden="true">
            <path
              d="M3 7A1.6 1.6 0 0 1 4.6 5.4h3.5l1.6 2h8.7A1.6 1.6 0 0 1 20 9v8.4A1.6 1.6 0 0 1 18.4 19H4.6A1.6 1.6 0 0 1 3 17.4V7Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        A workspace groups the locations you evaluate. Create one to start dropping pins,
        forecasting demand and comparing sites.
      </MapCallout>

      <Button size="lg" className="mt-[22px]" onClick={onCreateWorkspace}>
        <svg viewBox="0 0 18 18" fill="none" className="size-4" aria-hidden="true">
          <path d="M9 4v10M4 9h10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
        New workspace
      </Button>
    </div>
  );
}
